import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import es from "./es.json";
import en from "./en.json";

const savedLang = localStorage.getItem("balanza-lang");
const browserLang = navigator.language?.startsWith("es") ? "es" : "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en }
    },
    lng: savedLang || browserLang,
    fallbackLng: "es",
    interpolation: { escapeValue: false }
  });

export default i18n;
